import React from 'react';
import { Hero } from './components/Hero';
import { ProductCards } from './components/ProductCards';
import { Benefits } from './components/Benefits';
import { SocialProof } from './components/SocialProof';
import { ClosingCTA } from './components/ClosingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-[#FAFAF8] font-sans" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <ProductCards data-id="element-3" />
        <Benefits data-id="element-4" />
        <SocialProof data-id="element-5" />
        <ClosingCTA data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}